import { render, staticRenderFns } from "./SalesByTicketBlock.vue?vue&type=template&id=5a6fc67a"
import script from "./SalesByTicketBlock.vue?vue&type=script&lang=js"
export * from "./SalesByTicketBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports